/**
 * Says so when the app has lost the API.
 *
 * Someone exported ten clips, then watched a page poll for eighteen minutes
 * while every single request failed, and nothing on the screen changed. The
 * clips were finishing the whole time. A page that has stopped being true
 * should say so, and say the work carries on without it.
 */
import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { watchConnection } from '../api/connection';
import { useLocale } from '../i18n/LocaleContext';

export default function ConnectionBanner() {
  const { t } = useLocale();
  const [lost, setLost] = useState(false);

  useEffect(() => watchConnection(setLost), []);

  if (!lost) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-16 z-40 flex items-center justify-center gap-2 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-center text-sm text-amber-700 dark:text-amber-200"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{t('connection.lost')}</span>
      <span className="text-amber-200/70">{t('connection.retrying')}</span>
    </div>
  );
}
